module.exports = __webpack_public_path__ + "static/SweetSans-Regular-94df257bf5ba5e03a1cf165177f44864.woff2";